import React, { Fragment } from "react";
import { showAlert, showInfo } from "../store/actions/feedback";
import store from "../store";

export const showError = (errorText?: string) => {
  const alertText = "Internal error occurred";
  store.dispatch(
    showAlert({
      alertType: "error",
      alertText: errorText || alertText,
    })
  );
};

const showErrorMessage = (error, setFieldError) => {
  error.map((err) => {
    setFieldError(err?.key, err?.answers[0]?.errors[0]);
  });
};

const mergeErrors = (key: string, errors: any) => {
  return errors[key].map((err: any) => err.full_message).join(",");
};
const showPayrollFormErrors = (
  errors: any,
  setFieldError: (field: string, error: string) => void
) => {
  if (Array.isArray(errors)) {
    errors.map((err) => {
      Object.keys(err).forEach((key) => {
        if (key === "questions") {
          showErrorMessage(err[key], setFieldError);
        }
      });
    });
  } else {
    Object.keys(errors).forEach((key) => {
      if (key === "base") {
        store.dispatch(
          showInfo({
            infoData: (
              <Fragment>
                <ul>
                  {errors[key].map((err: any) => (
                    <li>{err.full_message}</li>
                  ))}
                </ul>
              </Fragment>
            ),
          })
        );
      } else {
        let errorMessage = mergeErrors(key, errors);
        setFieldError(key, errorMessage);
      }
    });
  }
};
export function formSubmitErrorHandler(
  submitRequest: Promise<any>,
  componentErrorHandler?: () => void,
  setFieldError?: (field: string, error: string) => void
) {
  submitRequest.catch((err) => {
    if (err?.status?.code >= 400) {
      if (err?.errors?.payroll_org_errors && setFieldError) {
        showPayrollFormErrors(err?.errors?.payroll_org_errors, setFieldError);
      } else {
        if (err?.errors && setFieldError) {
          Object.keys(err.errors).forEach((key) => {
            setFieldError(key, err.errors[key]);
          });
        }
      }
      showError(err?.statusText);
    }
    componentErrorHandler?.();
  });
}